<template>
  <div>
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        
      </section>
     

      <section class="section section-shaped my-0 overflow-hidden">
        <div class="shape shape-style-3 bg-gradient-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container  pb-300">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3 text-white">Partner With us</h2>
              <!-- <h2 class="display-3 text-white">Deepak Travel World (FollowMeTraveller.in or HotelLele.com)</h2> -->
              <p
                class="lead text-white"
              >You can reach us on below given details for any queries on our Services at Deepak Travel World, FollowMeTraveller and HotelLele.com</p>
            </div>
          </div>
         
        </div>
      </section>
      <section class="section  pt-lg-0 section-contact-us">
        <div class="container">
          <div class="row justify-content-center mt--300">
            <div class="col-lg-12">
              <card gradient="secondary" shadow body-classes="p-lg-5">
                <h4 class="mb-1 text-center">Want to add your hotel to HotelLele and FollowMeTraveller?</h4>
                <p
                  class="mt-0 text-center"
                >Please fill out the form below, we will get back to you shortly.</p>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      name="hotelname"
                      alternative
                      placeholder="Hotel Name"
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="totalfloor"
                      alternative
                      placeholder="Total Floor"

                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="totalroom"
                      alternative
                      placeholder="Total Room"
                    ></base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input class="mb-4">
                      <textarea
                        class="form-control form-control-alternative"
                        name="address"
                        rows="4"
                        cols="80"
                        placeholder="Hotel Address"
                      ></textarea>
                    </base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="phonenumber"
                      alternative
                      placeholder="Phone Number"
                    ></base-input>
                    <base-input
                      name="email"
                      alternative
                      placeholder="Email address"
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="mobilename"
                      alternative
                      placeholder="Mobile Number"
                    ></base-input>
                    <base-input
                      name="website"
                      alternative
                      placeholder="Website"
                    ></base-input>
                  </div>
                  <div class="col-lg-6">
                    <textarea
                      class="form-control form-control-alternative"
                      name="AmenitiesServices"
                      rows="4"
                      cols="80"
                      placeholder="Amenities & Services"
                    ></textarea>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="checkin"
                      alternative
                      placeholder="check-in"
                    ></base-input>
                    <base-input
                      name="airportnearby"
                      alternative
                      placeholder="Airport Nearby"
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="checkout"
                      alternative
                      placeholder="check-out"
                    ></base-input>
                    <base-input
                      name="travelareanearby"
                      alternative
                      placeholder="Travel Area Nearby"
                    ></base-input>
                  </div>
                  <div class="col-lg-6">
                    <textarea
                      class="form-control form-control-alternative"
                      name="restaurantsnearby"
                      rows="4"
                      cols="80"
                      placeholder="Restaurants Nearby"
                    ></textarea>
                  </div>
                  <div class="col-lg-6">
                    <textarea
                      class="form-control form-control-alternative"
                      name="anyother"
                      rows="4"
                      cols="80"
                      placeholder="Message"
                    ></textarea>
                  </div>
                  <div class="col-lg-12">
                    <h4 class="mb-3 mt-3 text-center">Contact Person or Sale Person</h4>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="personname"
                      alternative
                      placeholder="Contact Person Name"
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="personemailid"
                      alternative
                      placeholder="Contact Person Email Id"
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="personphone"
                      alternative
                      placeholder="Contact Person Phone No."
                    ></base-input>
                  </div>
                  <div class="col-lg-3">
                    <base-input
                      name="personmobile"
                      alternative
                      placeholder="Contact Person Mobiles"
                    ></base-input>
                  </div>
                  <div class="col-lg-12">
                    <base-input
                      name="img"
                      alternative
                      placeholder="Contact Person Mobiles"
                      type='file'
                      accept="image/*"
                      multiple='true'
                    ></base-input>
                  </div>
                  <div class="col-lg-4 offset-4 mt-5">
                      <base-button type="default" round block size="lg">Submit Details</base-button>
                  </div>
                </div>
              </card>
            </div>
          </div>
           <div class="row row-grid mt-5">
            <div class="col-lg-4">
              <icon name="ni ni-email-83" size="lg" gradient="white" shadow round color="primary"></icon>
              <h5 class=" mt-3">Email</h5>
              <p class=" mt-3">support@hotellele.com, deepaktravelworld@gmail.com</p>
            </div>
            <div class="col-lg-4">
              <icon
                name="ni ni-mobile-button"
                size="lg"
                gradient="white"
                shadow
                round
                color="primary"
              ></icon>
              <h5 class=" mt-3">Call us</h5>
              <p class=" mt-3">+91 - 80805 40540<br/> +91 - 91522 16606.</p>
            </div>
            <div class="col-lg-4">
              <icon name="ni ni-map-big" size="lg" gradient="white" shadow round color="primary"></icon>
              <h5 class="mt-3">Meet Us</h5>
              <p
                class="mt-3"
              >Shop No. 1, Manish Tower, Near Kanwarram Chowk, Station Road, Ulhasnagar 3, Ulhasnagar, Maharashtra 421003. INDIA.</p>
            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
</style>